export const SHOW_MENA_BANNER = "SHOW_MENA_BANNER";
export const DISMISS_MENA_BANNER = "DISMISS_MENA_BANNER";

// Enabled countries come from this flag's comma-separated `countryCodes` variable.
export const MENA_FEATURE_KEY = "stc-mena";

export const MENA_BANNER_DISMISSED_KEY = "Asos.SiteChrome.Redirection";
